import { render, staticRenderFns } from "./SignatureControl.vue?vue&type=template&id=56cbfa00&scoped=true&"
import script from "./SignatureControl.vue?vue&type=script&lang=ts&"
export * from "./SignatureControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cbfa00",
  null
  
)

export default component.exports